import useLocalStorage from '../utils/useLocalStorage';

function usePdfTransformSettings() {
  const [pdfScale, setPdfScale] = useLocalStorage('pdfScale', 1);
  const [pdfTranslateX, setPdfTranslateX] = useLocalStorage('pdfTranslateX', 0);
  const [pdfTranslateY, setPdfTranslateY] = useLocalStorage('pdfTranslateY', 0);
  const [scaleFromSheetCenter, setScaleFromSheetCenter] = useLocalStorage('scaleFromSheetCenter', false);

  return {
    pdfScale, setPdfScale,
    pdfTranslateX, setPdfTranslateX,
    pdfTranslateY, setPdfTranslateY,
    scaleFromSheetCenter, setScaleFromSheetCenter,
  };
}

export default usePdfTransformSettings;
